export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-slide-nav/index.js